<template>
  <div id="email-body" class="email contatto" style="position:absolute;top:0;left:0;"  >

    <table cellmargin="0" cellspacing="0" width="800" align="center" border="0" style="border:none;"><tr><td>


      <table cellmargin="0" cellspacing="0" width="800" align="center"><tr> 
        <td width="100%">
          <a href="https://www.siaip.it/" style="margin:10px 0 0 20px;"><img src="https://nl.biomedia.net/nlweb/images/siaip/headNew2025.png" style="width:800;border:none;"></a>
        </td>
      </tr></table>



      <table cellmargin="0" cellspacing="0" width="720" align="center"><tr> 
        <td style="margin:40px 0;">
          Siamo spiacenti la procedura con Banca Sella non è andata a buon fine
        </td>    
      </tr></table>

<h3>A</h3>
{{a}}
<h3>B</h3>
{{b}}

<h3>SELLA</h3>
{{sella}}





      <table cellmargin="0" cellspacing="0" width="800"><tr> 
         <td style="text-align:center;background:#666666;color:#ffffff;margin:20px;">
          TerAs
         </td>
      </tr></table>


  </td ></tr></table>
</div>
</template>

<script>
export default {
   props: ['a','b','sella'],
   beforeDestroy: function(){
     console.log("VM DISTRUTTA")
   }
}
</script>
